import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

import {
  actionFetchList,
  actionSendEvent,
  actionResetData,
} from 'modules/Stories/actions'

export const useStories = () => {
  const dispatch = useDispatch()

  const fetchList = useCallback((props) => dispatch(actionFetchList(props)), [])

  const sendEvent = useCallback(({ storyId, event }) => {
    dispatch(
      actionSendEvent({
        story_id: storyId,
        event,
      }),
    )
  }, [])

  const resetData = useCallback(() => dispatch(actionResetData()), [])

  return { fetchList, sendEvent, resetData }
}
